module.exports = __webpack_public_path__ + "img/1724249143960-IMG_1522.jpeg.7ec817ba.webp";